import * as React from 'react';
import { Helmet } from 'react-helmet';

export default (): JSX.Element => (
	<Helmet>
		<title>FSG Darksite</title>
	</Helmet>
);
